import { render, staticRenderFns } from "./jesse-if-i-had-the-words.vue?vue&type=template&id=448db2ae&"
import script from "./jesse-if-i-had-the-words.vue?vue&type=script&lang=js&"
export * from "./jesse-if-i-had-the-words.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports